import jQuery from 'jquery';
import 'slick-carousel';

;(function($){

function init(){

  /**
  ** [splash]
  **/
  const $splash = $('.p-topSplash');
  if($splash.length) {
    $('body').css('overflow', 'hidden');
    $(window).on('load', function(){
      $splash.addClass('is-loaded').delay(2500).queue(function(){
        $(this).dequeue();
        $splash.fadeOut(700,function(){
          $('body').removeAttr('style');
          $topVisual.slick('slickPlay');
        });
      });
    });
  }


  /**
  ** [topVisualSlider]
  **/
  const $topVisual = $('.p-topSlider');
  $topVisual.slick({
    pauseOnHover:false,
    pauseOnFocus:false,
    draggable:false,
    // autoplay:true,
    autoplaySpeed:3000,
    dots:true,
    arrows:false,
    fade:true,
    dotsClass:'slider-dots',
  });
  let stopBtn = $('<div class="slickBtnArea"><button id="tglBtn"><span id="startBtn">start</span><span id="stopBtn">stop</span></button></div>');
  $topVisual.after(stopBtn);
  $('#startBtn').hide();
  let flg = 'play';
  $('.slider-dots button').click(function(){
    $topVisual.slick('slickPlay');
    $('#startBtn').hide();
    $('#stopBtn').show();
    flg = 'play';
    $('.slider-dots li').removeClass('stop-active');
  });
  $('#tglBtn').click(function(){
    if(flg == 'play') {
      $('#startBtn').show();
      $('#stopBtn').hide();
      flg = "stop";
      $topVisual.slick('slickPause');
      $('.slick-active').addClass('stop-active');
    } else {
      $('#startBtn').hide();
      $('#stopBtn').show();
      flg = 'play';
      $topVisual.slick('slickPlay');
      $topVisual.slick('slickNext');
      $('.slider-dots li').removeClass('stop-active');
    }
  });

  /**
  ** [topSustennaSlider]
  **/
  $('.p-sustennaBox-slider').slick({
    slidesToShow:3,
    arrows:true,
    speed:1000,
    focusOnSelect:true,
    responsive: [
      {
        breakpoint: 813,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true
        }
      }
    ]
  });
  /**
  ** [topColormariSlider]
  **/
  $('.p-colormariBox-slider').slick({
    centerMode:true,
    slidesToShow:1,
    variableWidth:true,
    arrows:true,
    autoplaySpeed:4000,
    speed:1000,
    dots:true,
    focusOnSelect:true
  });
}
$(function(){
  init();
});

}(jQuery));